import { cleanNotifications, showNotification } from "@mantine/notifications";
import { axiosPost } from "../Helpers";

export const addAndEditData = async (values, setOpened, setUpdate, url) => {
  setOpened(false);
  cleanNotifications();
  console.log(values, "this is the values and url");

  axiosPost(url, values).then((response) => {
    console.log("Posted", url, response.data);
    if (!response.data.status) {
      showNotification({
        title: "Error",
        message: `${response.data.message}`,
        color: "red",
      });
    } else {
      setUpdate((prev) => !prev);
      setOpened(false);
      showNotification({
        title: "Success",
        message: `${response.data.message}`,
        color: "green",
      });
    }
  });
};
